import React from 'react';
import { Box, Text, Button, VStack } from '@chakra-ui/react';
export function PopUpBanner() {
  return <Box as="section" position="relative" w="100%" minH={{
    base: '420px',
    md: '500px'
  }} overflow="hidden" className="lace-border-top lace-border-bottom" data-id="element-165">
      {/* Background image */}
      <Box position="absolute" inset={0} className="hero-parallax" backgroundImage="url('https://cdn.magicpatterns.com/uploads/tABf6kXBotzy1fSXFisv9E/priscilla-du-preez-my5cwTzhmNI-unsplash.jpg')" backgroundSize="cover" backgroundPosition="center" data-id="element-166" />

      {/* Dark overlay */}
      <Box position="absolute" inset={0} bg="rgba(0,0,0,0.48)" data-id="element-167" />

      {/* Content */}
      <Box position="relative" zIndex={1} display="flex" alignItems="center" justifyContent="center" minH={{
      base: '420px',
      md: '500px'
    }} px={{
      base: 6,
      md: 12
    }} py={{
      base: 16,
      md: 20
    }} data-id="element-168">
        <VStack spacing={6} textAlign="center" maxW="680px" data-id="element-169">
          {/* Script accent */}
          <Text className="font-script" fontSize={{
          base: '22px',
          md: '28px'
        }} color="rgba(244,184,193,0.9)" data-id="element-170">
            find us in the wild
          </Text>

          {/* Headline */}
          <Text as="h2" className="font-serif" fontSize={{
          base: '30px',
          md: '42px'
        }} fontWeight={700} color="white" lineHeight={1.2} style={{
          textShadow: '0 2px 8px rgba(0,0,0,0.3)'
        }} data-id="element-171">
            Come Say Hi IRL 💕
          </Text>

          {/* Subtext */}
          <Text className="font-body" fontSize={{
          base: '15px',
          md: '17px'
        }} color="rgba(255,255,255,0.88)" lineHeight={1.7} maxW="520px" data-id="element-172">
            We love meeting you at local markets and pop-ups! Come shop, chat,
            and be part of the community.
          </Text>

          {/* CTA Button */}
          <Button bg="white" color="#C9929D" fontSize={{
          base: '15px',
          md: '16px'
        }} fontWeight={600} px={10} h="52px" borderRadius="24px" className="font-body" _hover={{
          bg: '#FAE0E4',
          transform: 'translateY(-2px)',
          boxShadow: '0 6px 20px rgba(0,0,0,0.2)'
        }} _active={{
          bg: '#F4B8C1'
        }} transition="all 0.25s" w={{
          base: '100%',
          sm: 'auto'
        }} minW={{
          sm: '240px'
        }} data-id="element-173">
            See Upcoming Events
          </Button>
        </VStack>
      </Box>
    </Box>;
}